<template>
  <div>
    <v-select
      v-model="item"
      :items="filters"
      :label="itemAction.name"
      :item-text="itemText"
      :item-value=" (itemAction.value) ? itemAction.value: 'id'"
      :disabled="itemAction.disabled"
      :append-outer-icon="(itemAction.loadingdata) ? (loading) ? ' mdi-loading mdi-spin' : 'mdi-refresh' : ''"
      @click:append-outer="openSelect"
      :multiple="itemAction.multiple"
      @click:clear="onClearData()"
      clearable
      outlined
      dense
    >
      <template v-slot:prepend-item>
        <v-sheet color="white" elevation="3" height="60" v-show="itemAction.search">
          <v-row dense>
            <v-col cols="12">
              <v-text-field class="pt-1 px-3" v-model="search" label="Buscar" outlined dense/>
            </v-col>
          </v-row>
        </v-sheet>

        <!-- <v-card dense tile elevation="0" v-show="itemAction.search">
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <v-text-field v-model="search" label="Buscar" outlined dense/>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card> -->

      </template>
      <template v-if="itemAction.multiple" #selection="{ item }">
        <v-list-item-action-text dense>
          <v-chip color="info" label outlined dense> {{ itemText(item) }} </v-chip>
        </v-list-item-action-text>
      </template>
      <template v-else #selection="{ item }">
        <v-list-item-action-text dense>
          <span class="font-weight-bold subtitle-2">{{ itemText(item) }}</span>
        </v-list-item-action-text>
      </template>

      <template v-if="itemAction.multiple" v-slot:item="{ item, attrs, on }">
        <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
          <v-list-item-action>
            <v-checkbox :input-value="active"></v-checkbox>
          </v-list-item-action>
            <v-list-item-content v-if="item.padre_id == 0">
              <span class="font-weight-bold subtitle-2">{{itemText(item)}}</span>
            </v-list-item-content>
            <v-list-item-content v-else class="pl-3" v-text="itemText(item)" />
        </v-list-item>
      </template>
      <template v-else #item="{ item }">
        <v-list-item-action-text dense>
          <span class="font-weight-bold font-weight-black">{{ itemText(item) }}</span>
        </v-list-item-action-text>
      </template>

    </v-select>
  </div>
</template>

<script>
import axios from 'axios'
import { HeaderGral } from '@/store/modules/config'
export default {
  props: ['itemAction', 'onSuccess', 'setterModel'],
  data: () => ({
    loading: false,
    item: null,
    items: [],
    filters: [],
    search: ''
  }),
  created () {
    this.laadData()
  },
  methods: {
    laadData () {
      if (this.itemAction.url) {
        if (this.itemAction.post) {
          this.postDinamicData(this.itemAction.url)
          return
        }
        this.getDinamicData(this.itemAction.url)
      } else {
        this.items = []
        this.items.push(...this.itemAction.items)
      }
    },
    itemText (item) {
      if (item && (this.itemAction.nameid === 'empleado_id' || this.itemAction.nameid === 'empleados' || this.itemAction.nameid === 'empleado')) return `${item.NombreCompleto}`
      if (item && (this.itemAction.nameid === 'usuario_id')) return `${item.usuario}`
      if (item && (this.itemAction.nameid === 'conceptos_id')) return `${item.conceptos}`
      if (item && (this.itemAction.nameid === 'caracteristica_id')) return `${item.nombre} - ${item.tipo_dato.nombre}`
      if (item && this.itemAction.nameid === 'articulo_id') return `${item.caracteristicas.codigo} - ${item.caracteristicas.descripcion}, ${item.caracteristicas.marca}, ${item.caracteristicas.modelo}, ${item.udm.nombre}`
      if (item && this.itemAction.nameid === 'almacen_id') return `${item.sucursal.nombre} - ${item.nombre}`
      if (item && (this.itemAction.nameid === 'fuente_financiamiento_id')) return `${item.nombre} - ${item.tipo}`
      return `${item.nombre}`
    },
    getDinamicData (url) {
      const header = HeaderGral()
      const p = (this.itemAction.params) ? this.itemAction.params : ''
      axios.get(`${url}${p}`, header).then((response) => {
        this.items = []
        this.items.push(...response.data)
        this.loading = false
        this.filters = []
        this.filters.push(...this.items)
      }).catch((error) => {
        if (error == null) console.log('Error')
      })
    },
    postDinamicData (url) {
      const header = HeaderGral()
      axios.post(url, {}, header).then((response) => {
        this.items = []
        this.items.push(...response.data)
        this.loading = false
        this.filters = []
        this.filters.push(...this.items)
      }).catch((error) => {
        if (error == null) console.log('Error')
      })
    },
    setDefault (items) {
      if (this.itemAction.default) {
        if (this.itemAction.nameid === 'ejercicio_id') {
          const year = new Date().toISOString().substr(0, 4)
          items.map((periodo) => {
            if (periodo.anio >= year) this.item = periodo.id
          })
        }
      }
    },
    openSelect () {
      this.loading = true
      setTimeout(() => { this.laadData() }, 1000)
    },
    onClearData () {
      this.onSuccess({
        id: this.itemAction.nameid,
        data: null,
        objectnameid: this.itemAction.object_name,
        objectdata: null,
        fieldMain: this.itemAction
      })
    }
  },
  watch: {
    item (val) {
      const model = this.items.find((item) => item[this.itemAction.value] === val)
      this.onSuccess({
        id: this.itemAction.nameid,
        data: val,
        nameObject: this.itemAction.objectname,
        objectMain: model,
        fieldMain: this.itemAction
      })
    },
    items (vals) {
      if (this.setterModel) this.item = this.setterModel
    },
    search (val) {
      if (val === '') {
        this.filters = []
        this.filters.push(...this.items)
        return
      }
      if (this.itemAction.nameid === 'empleados') {
        this.filters = this.items.filter(item => item.NombreCompleto.toLowerCase().includes(val.toLowerCase()))
      }
      if (this.itemAction.nameid === 'departamento_id') {
        this.filters = this.items.filter(item => item.nombre.toLowerCase().includes(val.toLowerCase()))
      }
    }
  }
}
</script>

<style>
</style>
